import { observer } from 'mobx-react-lite';
import { TradePlan } from '../../../../../../../classes/tradePlan/tradePlanTypes';
import { colors } from '../../../../../../../colorVars';
import { useWebsocketStore } from '../../../../../../../stores/websocketStore/websocketProvider';
import ApplyRounding from '../../../../../../../utils/math/ApplyRounding';
import { Body3 } from '../../../../../../atomic/text/Text';
import { getSetupName } from './getSetupName';

type Props = {
  tradePlanId: string;
};

export const SetupComponent = observer(({ tradePlanId }: Props) => {
  const { tradePlanStore } = useWebsocketStore();
  const tradePlan: TradePlan = tradePlanStore.tradePlans[tradePlanId];
  const setup: string = tradePlan.setup;
  const name = getSetupName(setup);
  let triggerPrice = 'N/A';
  if (!tradePlan.inPosition) {
    const setupInfo =
      tradePlanStore.currentSetupInfoByTradePlanId[tradePlanId] ?? null;
    if (setupInfo.triggerPrice) {
      if (setupInfo.triggerPrice.priceToBreakHigh) {
        triggerPrice = `$${ApplyRounding(
          Number(setupInfo.triggerPrice.priceToBreakLow),
          2
        )}/$${ApplyRounding(
          Number(setupInfo.triggerPrice.priceToBreakHigh),
          2
        )}`;
      } else if (setupInfo.triggerPrice.priceToBreak) {
        triggerPrice = `$${ApplyRounding(
          Number(setupInfo.triggerPrice.priceToBreak),
          2
        )}`;
      }
    }
  }
  return (
    <div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr' }}>
        <Body3 color={colors.lightGrey} fontWeight={500} margin="0 0 0 0">
          {name}
        </Body3>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr' }}>
        <Body3 color={colors.lightGrey} fontWeight={700}>
          Trig:
        </Body3>
        <Body3 color={colors.lightGrey} fontWeight={500}>
          {triggerPrice}
        </Body3>
      </div>
    </div>
  );
});
